import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { putRequest } from '../../requestUtils';
import { analyticsTrack } from '../../analyticsUtils';
import './AddProject.scss';
import FilterTag from '../common/FilterTag';
import customStyles from '../../dropdownStyleUtils';
import DropdownIndicator from '../common/DropdownIndicator';
import DocumentUpload from '../DocumentUpload';

const firstName = (consultant) => (consultant.name ? consultant.name.split(' ')[0] : consultant.email);

const handleCancel = () => {
  window.location.href = '/projects';
};

const handleAfterUpload = (redirectUrl) => {
  analyticsTrack('Uploaded job description', { location: 'Add Project' });
  window.location = redirectUrl;
};

const additionalLabelStyle = {
  marginLeft: 0,
};

class AddProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      duplicateProject: null,
      selectedProject: null,
      selectedTemplate: null,
    };

    this.handleRadio = this.handleRadio.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleNewProject = this.handleNewProject.bind(this);
    this.handleSelectTemplate = this.handleSelectTemplate.bind(this);
  }

  generateTitleCopy() {
    const { hireAgain, consultant } = this.props;

    if (hireAgain) {
      return `Which project do you want to hire ${firstName(consultant)} for?`;
    }

    return 'Easy ways to post a new project';
  }

  generateSubtitleCopy() {
    const { hireAgain, consultant } = this.props;

    if (hireAgain) {
      return `Clora will share this information with ${firstName(consultant)} and check their availability.`;
    }
    return null;
  }

  isContinueDisabled() {
    const { duplicateProject, selectedTemplate, selectedProject } = this.state;

    return (duplicateProject === null && selectedTemplate === null)
       || (duplicateProject === true && selectedProject === null);
  }

  handleRadio(bool) {
    this.setState({ duplicateProject: bool, selectedTemplate: null });
  }

  handleSelect(option) {
    this.setState({ selectedProject: option });
  }

  handleNewProject() {
    const {
      hireAgain, onCreateNewProject, consultant, csrfToken,
    } = this.props;
    const { duplicateProject, selectedProject, selectedTemplate } = this.state;

    if (duplicateProject) {
      const duplicateProjectPath = `/projects/${selectedProject.value}/duplicate`;
      const params = {};

      if (hireAgain) {
        params.rehire_user_resource_id = consultant.resource_id;
      }

      analyticsTrack('Created Duplicate Project', { location: 'Add Project' });
      putRequest(
        duplicateProjectPath,
        params,
        csrfToken,
      ).then((response) => {
        window.location.href = response.data.url;
      });
    } else if (hireAgain) {
      onCreateNewProject();
    } else if (selectedTemplate) {
      window.location.href = `/projects/new?project_template_id=${selectedTemplate}`;
    } else {
      window.location.href = '/projects/new';
    }
  }

  handleSelectTemplate(templateId) {
    this.setState({ selectedTemplate: templateId, duplicateProject: null });
  }

  renderTemplateSelect() {
    const { projectTemplates } = this.props;
    const { selectedTemplate } = this.state;
    const projectTemplateOptions = projectTemplates.map((template) => (
      { title: template.name, value: template.id }
    ));

    return (
      <Fragment>
        <div className="heading-subtext ps-0">
          Quick start with our templates to pre-fill your project details.
        </div>
        <div className="filter-tag-spacing">
          <FilterTag
            options={projectTemplateOptions}
            handleChange={this.handleSelectTemplate}
            selected={selectedTemplate}
          />
        </div>
      </Fragment>
    );
  }

  render() {
    const { projects, csrfToken } = this.props;
    const { duplicateProject, selectedProject } = this.state;

    const titleCopy = this.generateTitleCopy();
    const subtitleCopy = this.generateSubtitleCopy();

    return (
      <div className="style-guide add-project">
        <div className="row">
          <h2 className="mb-3 ps-0">{titleCopy}</h2>
          <p className="body-text-2 mb-4 ps-0">{subtitleCopy}</p>
          <div className="subheading mb-3 ps-0">Import your existing job description</div>
        </div>
        <div className="row">
          <DocumentUpload
            buttonStyle="button"
            prompt="Upload"
            uploadDocumentUrl="/projects/create_from_jd"
            document={null}
            csrfToken={csrfToken}
            documentType="job_description"
            location="Add Project"
            handleAfterUpload={handleAfterUpload}
            skipParsing
          />
        </div>
        <div className="row or-divider">
          OR
        </div>
        <div className="row subheading mb-3">Use our templates</div>
        <div className="row body-text-2" />
        <div className="row template-select">
          { this.renderTemplateSelect() }
        </div>
        <div className="row or-divider">
          OR
        </div>
        <div className="row subheading mb-3">Write your own</div>
        <div className="row option" key="duplicate-project">
          <label
            htmlFor="duplicate-project"
            className="custom-radio-container"
            style={additionalLabelStyle}
          >
            <input
              type="radio"
              id="duplicate-project"
              value="duplicate-project"
              name="duplicate-project"
              onChange={() => this.handleRadio(true)}
              checked={duplicateProject === true}
            />
            <span className="radio-btn" />
            <span className="radio-text">Duplicate my other project</span>
          </label>

          { duplicateProject
            && (
            <div className="select-projects mt-2 mb-2">
              <Select
                components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                styles={customStyles}
                className="body-text-2"
                classNamePrefix="selected-project"
                placeholder="Choose a project"
                options={projects.map((p) => ({ value: p.resource_id, label: p.name }))}
                value={selectedProject}
                onChange={(option) => this.handleSelect(option)}
              />
            </div>
            )}
        </div>
        <div className="row form-group body-text-2 my-3">
          <div className="option mb-3" key="add-project">
            <label
              htmlFor="add-project"
              className="custom-radio-container"
              style={additionalLabelStyle}
            >
              <input
                type="radio"
                id="add-project"
                value="add-project"
                name="add-project"
                onChange={() => this.handleRadio(false)}
                checked={duplicateProject === false}
              />
              <span className="radio-btn" />
              <span className="radio-text">
                I&apos;ll start from scratch
              </span>
            </label>
          </div>

        </div>
        <div className="actions actions d-flex flex-column flex-md-row justify-content-end gap-3">
          <a
            className="cancel btn"
            tabIndex={0}
            role="button"
            onClick={() => handleCancel()}
          >
            Cancel
          </a>
          <button
            className={`continue${this.isContinueDisabled() ? '-disabled' : ''} btn btn-primary`}
            disabled={this.isContinueDisabled()}
            onClick={this.handleNewProject}
          >
            Continue
          </button>
        </div>
      </div>
    );
  }
}

AddProject.propTypes = {
  projects: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  projectTemplates: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  hireAgain: PropTypes.bool,
  consultant: PropTypes.shape({}),
  onCreateNewProject: PropTypes.func,
  csrfToken: PropTypes.string,
};

AddProject.defaultProps = {
  hireAgain: false,
  consultant: null,
  onCreateNewProject: () => null,
  csrfToken: null,
};

export default AddProject;
